import { withTheme } from 'styled-components'
import MobileNavigation from './MobileNavigation'

export default withTheme(MobileNavigation)
